import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Tooltip,
} from "@mui/material";
import axios from "axios";
import { Button } from "react-bootstrap";
import { fetchInstructorLead } from "../../Redux/Reducers/InstructorLeadsReducer";
import PageHeader1 from "../../components/common/PageHeader1";
import { usePermissions } from "../../context/AuthContext";

function InstructorLeads() {
  const { can } = usePermissions();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({});
  const leads = useSelector((state) => state?.InstructorLeadsReducer?.instructors);
  const pagination = useSelector((state) => state?.InstructorLeadsReducer?.pagination);
  const loading = useSelector((state) => state?.InstructorLeadsReducer?.loading);

  const [filterModel, setFilterModel] = useState({
    items: [],
    quickFilterExcludeHiddenColumns: true,
    quickFilterValues: [""],
  });

  useEffect(() => {
    const { page, pageSize } = paginationModel;
    dispatch(fetchInstructorLead({ page: page + 1, limit: pageSize }));
  }, [paginationModel, dispatch]);

  const rows = Array.isArray(leads)
    ? leads.map((item, index) => ({
      id: item?._id || `temp-id-${index}`,
      sono: paginationModel.page * paginationModel.pageSize + index + 1,
      name: item?.name || "-",
      mobile: item?.mobile || "-",
      email: item?.email || "-",
      expertise: item?.expertise || "-",
      createdAt: item?.createdAt
        ? new Date(item?.createdAt).toLocaleString()
        : "",
    }))
    : [];

  function deleteLead(id) {
    const token = localStorage.getItem("vedhvidhi-admin-token");

    axios
      .delete(`${process.env.REACT_APP_BASEURL}/admin/instructor/${id}`, {
        headers: {
          Authorization: token,
        },
      })
      .then((response) => {
        if (response.data.statusCode) {
          const { page, pageSize } = paginationModel;
          dispatch(fetchInstructorLead({ page: page + 1, limit: pageSize }));
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  const handleClickOpen = (id) => {
    setSelectedUserId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedUserId(null);
  };

  const handleDelete = () => {
    if (selectedUserId) {
      deleteLead(selectedUserId);
    }
    handleClose();
  };

  const columns = [
    { field: "sono", headerName: "S.No", width: 150 },
    { field: "name", headerName: "Name", width: 180 },
    { field: "mobile", headerName: "Mobile No.", width: 180 },
    { field: "email", headerName: "Email", width: 250 },
    { field: "expertise", headerName: "Expertise", width: 260 },
    { field: "createdAt", headerName: "Created At", width: 200 },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      renderCell: ({ row }) => (
        <div>
          <span className="badge bg-success">Active</span>
        </div>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      renderCell: ({ row }) => (
        <div>
          {can('instructor_leads:delete') && (
            <Tooltip title="Delete Lead">
              <IconButton onClick={() => handleClickOpen(row.id)}>
                <i className="icofont-ui-delete text-danger"></i>
              </IconButton>
            </Tooltip>
          )}
        </div>
      ),
    },
  ];

  return (
    <div className="body d-flex py-1">
      <div className="container-xxl">
        <div className="row g-0 mb-3">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <PageHeader1 pagetitle='Instructor Leads List' />
                <div
                  id="myDataTable_wrapper"
                  className="dataTables_wrapper dt-bootstrap5 no-footer"
                >
                  <div className="row">
                    <div className="col-sm-12">
                      <Box sx={{ width: 1 }}>
                        <Box
                          sx={{
                            height: 400,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {loading ? (
                            <CircularProgress />
                          ) : (
                            <DataGrid
                              columns={columns}
                              rows={rows}
                              getRowId={(row) => row.id}
                              disableColumnFilter
                              disableDensitySelector
                              slots={{ toolbar: GridToolbar }}
                              filterModel={filterModel}
                              onFilterModelChange={(newModel) =>
                                setFilterModel(newModel)
                              }
                              slotProps={{ toolbar: { showQuickFilter: true } }}
                              columnVisibilityModel={columnVisibilityModel}
                              onColumnVisibilityModelChange={(newModel) =>
                                setColumnVisibilityModel(newModel)
                              }
                              paginationMode="server"
                              rowCount={pagination?.totalDocs || 0}
                              pageSizeOptions={[10, 25, 50, 100]}
                              paginationModel={paginationModel}
                              onPaginationModelChange={setPaginationModel}
                              disableRowSelectionOnClick
                            />
                          )}
                        </Box>
                      </Box>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Delete Confirmation"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete this record?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} variant="secondary">
              Cancel
            </Button>
            <Button onClick={handleDelete} variant="danger" autoFocus>
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
}

export default InstructorLeads;